import React from "react";

import { Building2 } from "lucide-react";

import type { SignalAdminOrganization } from "./types";

interface OrgSelectProps {
  organizations: SignalAdminOrganization[];
  value: string;
  onChange: (orgId: string) => void;
  loading?: boolean;
  disabled?: boolean;
  emptyLabel?: string;
  className?: string;
  size?: "sm" | "md";
}

const OrgSelect: React.FC<OrgSelectProps> = ({
  organizations,
  value,
  onChange,
  loading = false,
  disabled = false,
  emptyLabel = "Select organization…",
  className = "",
  size = "md",
}) => {
  const height = size === "sm" ? "h-8 text-[12.5px]" : "h-9 text-[13px]";
  return (
    <div className={`relative ${className}`}>
      <Building2
        className="pointer-events-none absolute left-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400"
        aria-hidden
      />
      <select
        aria-label="Organization"
        value={value}
        onChange={e => onChange(e.target.value)}
        disabled={disabled || loading}
        className={`${height} min-w-[220px] rounded-lg border border-gray-300 bg-white pl-8 pr-8 font-medium text-gray-900 focus:border-brand focus:outline-none focus:ring-2 focus:ring-brand/20 disabled:cursor-not-allowed disabled:bg-gray-50`}
      >
        <option value="">
          {loading ? "Loading organizations…" : emptyLabel}
        </option>
        {organizations.map(org => (
          <option key={org.org_id} value={org.org_id}>
            {org.org_name}
            {org.is_active ? "" : " (inactive)"}
          </option>
        ))}
      </select>
    </div>
  );
};

export default OrgSelect;
